import Immutable from 'immutable';
import { createMigration } from './utils';

const greyscaleDesigns = [
    'google:text_1b',
    'google:text_2b',
    'google:text_3b',
    'google:text_4b',
    'google:text_5b',
    'google:title_1b',
    'google:title_3b',
    'google:title_5b',
    'google:title_7b',
    'google:quote_2b',
    'google:quote_3b',
    'google:quote_4b',
    'google:quote_5b',
    'google:quote_6b',
    'google:quote_7b',
    'clean_gapless_bars:text_4b',
];

const DEFAULT_FILTER = {
    'classType': 'GreyscaleFilter',
    'name': 'GreyscaleFilter_1',
    'greyscale': 0.4,
};

export const migrationTo9_162 = createMigration({
    migrateVideo(video) {
        return video.withMutations(map => {
            map.get('slides').forEach((scene, i) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
        });
    },
    migrateScene(scene) {
        return scene.withMutations(map => {
            const sceneDesign = map.get('sceneDesign');

            if (!greyscaleDesigns.includes(sceneDesign)) {
                return;
            }

            (map.getIn(['children'], []) as Immutable.List<any>).forEach((asset, i) => {
                if (asset.get('name') === 'media_1') {
                    let filters = asset.get('filters', []);
                    if (filters === null) {
                        filters = [];
                    }
                    else {
                        filters = filters.toJS();
                    }

                    const hasGreyscaleFilter = filters.filter(f => (f as any).classType === 'GreyscaleFilter').length > 0;
                    if (!hasGreyscaleFilter) {
                        map.setIn(['children', i, 'filters'], Immutable.fromJS([...filters, DEFAULT_FILTER]));
                    }
                }
            });
        });
    },
});
